var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8906 20.1758C15.9576 20.1758 14.3906 18.6088 14.3906 16.6758C14.3906 14.7428 15.9576 13.1758 17.8906 13.1758C19.8236 13.1758 21.3906 14.7428 21.3906 16.6758C21.3906 18.6088 19.8236 20.1758 17.8906 20.1758Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 20.1758C4.567 20.1758 3 18.6088 3 16.6758C3 14.7428 4.567 13.1758 6.5 13.1758C8.433 13.1758 10 14.7428 10 16.6758C10 18.6088 8.433 20.1758 6.5 20.1758Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1914 10C10.2584 10 8.69141 8.433 8.69141 6.5C8.69141 4.567 10.2584 3 12.1914 3C14.1244 3 15.6914 4.567 15.6914 6.5C15.6914 8.433 14.1244 10 12.1914 10Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.4d91a1e7be3f3290767658bd6dd473da.svg";
export { ForwardRef as ReactComponent };